<div class="performance-rate__element">
  <div class="performance-rate__rect-container">
    <div class="performance-rate__value">{{ formatValue(value) }}t</div>
    <div [style.backgroundColor]="color" [style.height]="height" class="performance-rate__rect"></div>
  </div>
  <div matTooltipPosition="above" [matTooltip]="label" class="performance-rate__label">
    {{ label }}
  </div>
</div>
